import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import RegistrationScreenshot from "./mobile/registration";
import DashboardScreenshot from "./mobile/dashboard";

export default function ScreenshotRouter() {
  const { path } = useRouteMatch();

  return (
    <div style={{ background: "#F5F5F7", minHeight: "100vh" }}>
      <Switch>
        <Route path={`${path}/mobile/registration`} component={RegistrationScreenshot} />
        <Route path={`${path}/mobile/dashboard`} component={DashboardScreenshot} />
        <Redirect from={path} to={`${path}/mobile/registration`} />
      </Switch>
    </div>
  );
}
